<template>
    <v-list>
        <v-list-item link to="home">
        <v-list-item-avatar>
          <img src = "@/assets/perfil.png" alt="perfil"/>
        </v-list-item-avatar>
        <v-list-item-title>{{ user }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout()">
            <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title>
                Logout
            </v-list-item-title>
            </v-list-item-content>  
        </v-list-item>
    </v-list>
</template>

<script lang="ts">
    import Vue from 'vue'
    import { logout, getUser } from '../utilitys/auth'
    export default Vue.extend({
        name:'Usersection',
        data: () => ({
            user: getUser(),
        }),
        methods:{
            logout: function(){
               logout()
            }
        }
    })
</script>